document.addEventListener('DOMContentLoaded', function() {
  let base_url = str(document.location);
  if (!base_url.endsWith('/'))
    base_url += '/';
  fetch(`${base_url}timetable/talk`, {method: 'GET'})
  .then((response) => {
    if (response.ok) {
      response.json()
      .then((body) => {
        const event_id = base_url.split('/event/')[1].split('/')[0];
        let msg = '';
        let talk_id = 0;
        for (let i = 0; i < body['talks'].length; i++) {
          const talk = JSON.parse(body['talks'][i]);
          if (talk['event_id'] == event_id) {
            talk_id = talk['id'];
            msg = `You are a speaker at this event. You can modify the title and abstract of your talk <a href="${base_url}timetable/manage/${talk_id}"> here</a>.`;
            break;
          }
        }
        for (let i = 0; i < body['invites'].length; i++) {
          const invite = JSON.parse(body['invites'][i]);
          if (invite['schedule_item_id'] == talk_id) {
            msg = `You have been invited as a speaker at this event. Please provide a title and abstract for your talk <a href="${base_url}timetable/talk/${invite['token']}"> here</a>.`;
            break;
          }
        }
        if (talk_id) {
          const invitation_notice = document.createElement('div');
          invitation_notice.setAttribute('class', 'infoline info');
          invitation_notice.innerHTML = `<span class="icon icon-calendar"></span><div class="text"><p>${msg}</p></div>`;
          document.querySelector('.infogrid').prepend(invitation_notice);
        }
      });
    }
  });
});
